import router from '@/router'
import useApp from '@/composables/app'
import appConstants from '@/constants/constants'
import useWindow from '@/composables/window'
import { showInactiveSessionToast } from '@/composables/toast'
import ability from '@/libs/acl/ability'
import { getUserAbilities } from '@/composables/currentUser'
import useSocket from '@/composables/socket'

export const broadcastChannel = new BroadcastChannel('app_broadcast_channel')

broadcastChannel.onmessage = event => {
  if (event.data && event.data.type) {
    if (event.data.type === 'LOGOUT') {
      handleLogoutMessage(event.data)
    }
    if (event.data.type === 'LOGIN') {
      handleLoginMessage()
    }
  }
}

const handleLogoutMessage = data => {
  const reason = data.reason
  const { clearUserOnlineChecker } = useWindow()
  const { clearUserSocketConnection } = useSocket()

  clearUserSocketConnection()
  clearUserOnlineChecker()
  if (router.currentRoute.name !== 'auth-login') {
    if ([
      appConstants.auth.logoutReason.INACTIVE_SESSION, appConstants.auth.logoutReason.END_OF_SESSION
    ].includes(reason)) {
      showInactiveSessionToast(reason)
    }
    router.push({ name: 'auth-login' })
  }
}

const handleLoginMessage = () => {
  if (router.currentRoute.name === 'auth-login') {
    const { connectToUserSocket } = useSocket()
    const { goToHomePage } = useApp()
    const { setUserOnlineChecker } = useWindow()
    ability.update(getUserAbilities())
    connectToUserSocket(true)
    setUserOnlineChecker()
    goToHomePage()
  }
}
